import React, { Fragment } from "react";
import { graphql } from "gatsby";
import Block from "../../Block";

class CoreImage extends Block {
  render() {
    const { block } = this.props;
    return <div className="text-center" dangerouslySetInnerHTML={{ __html: block.originalContent }} />
  }
}

export const query = graphql`
  fragment BlogBlockImage on WpCoreImageBlock {
    originalContent
  }
`;

class CoreImageFactory {
  get type() {
    return "core/image";
  }

  create(props) {
    return <CoreImage {...props} />;
  }
}

export default CoreImageFactory;
